// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Edto","toggle":"styles_toggle__1bhwV","preview":"styles_preview__2fonG"};